/**
 * multiple-select - Multiple select is a jQuery plugin to select multiple elements with checkboxes :).
 *
 * @version v1.7.0
 * @homepage http://multiple-select.wenzhixin.net.cn
 * @author wenzhixin <wenzhixin2010@gmail.com> (http://wenzhixin.net.cn/)
 * @license MIT
 */

!(function (t, e) {
	'object' == typeof exports && 'undefined' != typeof module
		? e(require('jquery'))
		: 'function' == typeof define && define.amd
			? define(['jquery'], e)
			: e((t = 'undefined' != typeof globalThis ? globalThis : t || self).jQuery)
})(this, function (t) {
	'use strict'
	function e(t) {
		return (
			(e =
				'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
					? function (t) {
							return typeof t
						}
					: function (t) {
							return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? 'symbol' : typeof t
						}),
			e(t)
		)
	}
	function n(t, e) {
		if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function')
	}
	function i(t, e) {
		for (var n = 0; n < e.length; n++) {
			var i = e[n]
			;(i.enumerable = i.enumerable || !1),
				(i.configurable = !0),
				'value' in i && (i.writable = !0),
				Object.defineProperty(
					t,
					((u = i.key),
					(r = void 0),
					'symbol' ==
					typeof (r = (function (t, e) {
						if ('object' != typeof t || null === t) return t
						var n = t[Symbol.toPrimitive]
						if (void 0 !== n) {
							var i = n.call(t, e || 'default')
							if ('object' != typeof i) return i
							throw new TypeError('@@toPrimitive must return a primitive value.')
						}
						return ('string' === e ? String : Number)(t)
					})(u, 'string'))
						? r
						: String(r)),
					i,
				)
		}
		var u, r
	}
	function u(t, e, n) {
		return e && i(t.prototype, e), n && i(t, n), Object.defineProperty(t, 'prototype', { writable: !1 }), t
	}
	function r(t, e) {
		return (
			(function (t) {
				if (Array.isArray(t)) return t
			})(t) ||
			(function (t, e) {
				var n = null == t ? null : ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator']
				if (null != n) {
					var i,
						u,
						r,
						o,
						s = [],
						a = !0,
						l = !1
					try {
						if (((r = (n = n.call(t)).next), 0 === e)) {
							if (Object(n) !== n) return
							a = !1
						} else for (; !(a = (i = r.call(n)).done) && (s.push(i.value), s.length !== e); a = !0);
					} catch (t) {
						;(l = !0), (u = t)
					} finally {
						try {
							if (!a && null != n.return && ((o = n.return()), Object(o) !== o)) return
						} finally {
							if (l) throw u
						}
					}
					return s
				}
			})(t, e) ||
			s(t, e) ||
			(function () {
				throw new TypeError(
					'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
				)
			})()
		)
	}
	function o(t) {
		return (
			(function (t) {
				if (Array.isArray(t)) return a(t)
			})(t) ||
			(function (t) {
				if (('undefined' != typeof Symbol && null != t[Symbol.iterator]) || null != t['@@iterator']) return Array.from(t)
			})(t) ||
			s(t) ||
			(function () {
				throw new TypeError(
					'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
				)
			})()
		)
	}
	function s(t, e) {
		if (t) {
			if ('string' == typeof t) return a(t, e)
			var n = Object.prototype.toString.call(t).slice(8, -1)
			return (
				'Object' === n && t.constructor && (n = t.constructor.name),
				'Map' === n || 'Set' === n ? Array.from(t) : 'Arguments' === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? a(t, e) : void 0
			)
		}
	}
	function a(t, e) {
		;(null == e || e > t.length) && (e = t.length)
		for (var n = 0, i = new Array(e); n < e; n++) i[n] = t[n]
		return i
	}
	function l(t, e) {
		var n = ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator']
		if (!n) {
			if (Array.isArray(t) || (n = s(t)) || (e && t && 'number' == typeof t.length)) {
				n && (t = n)
				var i = 0,
					u = function () {}
				return {
					s: u,
					n: function () {
						return i >= t.length ? { done: !0 } : { done: !1, value: t[i++] }
					},
					e: function (t) {
						throw t
					},
					f: u,
				}
			}
			throw new TypeError(
				'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
			)
		}
		var r,
			o = !0,
			a = !1
		return {
			s: function () {
				n = n.call(t)
			},
			n: function () {
				var t = n.next()
				return (o = t.done), t
			},
			e: function (t) {
				;(a = !0), (r = t)
			},
			f: function () {
				try {
					o || null == n.return || n.return()
				} finally {
					if (a) throw r
				}
			},
		}
	}
	var c =
			'undefined' != typeof globalThis
				? globalThis
				: 'undefined' != typeof window
					? window
					: 'undefined' != typeof global
						? global
						: 'undefined' != typeof self
							? self
							: {},
		h = function (t) {
			return t && t.Math == Math && t
		},
		f =
			h('object' == typeof globalThis && globalThis) ||
			h('object' == typeof window && window) ||
			h('object' == typeof self && self) ||
			h('object' == typeof c && c) ||
			(function () {
				return this
			})() ||
			c ||
			Function('return this')(),
		d = {},
		p = function (t) {
			try {
				return !!t()
			} catch (t) {
				return !0
			}
		},
		v = !p(function () {
			return (
				7 !=
				Object.defineProperty({}, 1, {
					get: function () {
						return 7
					},
				})[1]
			)
		}),
		g = !p(function () {
			var t = function () {}.bind()
			return 'function' != typeof t || t.hasOwnProperty('prototype')
		}),
		E = g,
		b = Function.prototype.call,
		y = E
			? b.bind(b)
			: function () {
					return b.apply(b, arguments)
				},
		m = {},
		A = {}.propertyIsEnumerable,
		C = Object.getOwnPropertyDescriptor,
		F = C && !A.call({ 1: 2 }, 1)
	m.f = F
		? function (t) {
				var e = C(this, t)
				return !!e && e.enumerable
			}
		: A
	var S,
		k,
		D = function (t, e) {
			return { enumerable: !(1 & t), configurable: !(2 & t), writable: !(4 & t), value: e }
		},
		x = g,
		w = Function.prototype,
		O = w.call,
		$ = x && w.bind.bind(O, O),
		B = x
			? $
			: function (t) {
					return function () {
						return O.apply(t, arguments)
					}
				},
		j = B,
		T = j({}.toString),
		L = j(''.slice),
		I = function (t) {
			return L(T(t), 8, -1)
		},
		R = p,
		_ = I,
		M = Object,
		P = B(''.split),
		N = R(function () {
			return !M('z').propertyIsEnumerable(0)
		})
			? function (t) {
					return 'String' == _(t) ? P(t, '') : M(t)
				}
			: M,
		H = function (t) {
			return null == t
		},
		U = H,
		G = TypeError,
		W = function (t) {
			if (U(t)) throw G("Can't call method on " + t)
			return t
		},
		z = N,
		K = W,
		V = function (t) {
			return z(K(t))
		},
		q = 'object' == typeof document && document.all,
		Y = { all: q, IS_HTMLDDA: void 0 === q && void 0 !== q },
		X = Y.all,
		J = Y.IS_HTMLDDA
			? function (t) {
					return 'function' == typeof t || t === X
				}
			: function (t) {
					return 'function' == typeof t
				},
		Z = J,
		Q = Y.all,
		tt = Y.IS_HTMLDDA
			? function (t) {
					return 'object' == typeof t ? null !== t : Z(t) || t === Q
				}
			: function (t) {
					return 'object' == typeof t ? null !== t : Z(t)
				},
		et = f,
		nt = J,
		it = function (t, e) {
			return arguments.length < 2 ? ((n = et[t]), nt(n) ? n : void 0) : et[t] && et[t][e]
			var n
		},
		ut = B({}.isPrototypeOf),
		rt = f,
		ot = ('undefined' != typeof navigator && String(navigator.userAgent)) || '',
		st = rt.process,
		at = rt.Deno,
		lt = (st && st.versions) || (at && at.version),
		ct = lt && lt.v8
	ct && (k = (S = ct.split('.'))[0] > 0 && S[0] < 4 ? 1 : +(S[0] + S[1])),
		!k && ot && (!(S = ot.match(/Edge\/(\d+)/)) || S[1] >= 74) && (S = ot.match(/Chrome\/(\d+)/)) && (k = +S[1])
	var ht = k,
		ft = ht,
		dt = p,
		pt = f.String,
		vt =
			!!Object.getOwnPropertySymbols &&
			!dt(function () {
				var t = Symbol()
				return !pt(t) || !(Object(t) instanceof Symbol) || (!Symbol.sham && ft && ft < 41)
			}),
		gt = vt && !Symbol.sham && 'symbol' == typeof Symbol.iterator,
		Et = it,
		bt = J,
		yt = ut,
		mt = Object,
		At = gt
			? function (t) {
					return 'symbol' == typeof t
				}
			: function (t) {
					var e = Et('Symbol')
					return bt(e) && yt(e.prototype, mt(t))
				},
		Ct = String,
		Ft = function (t) {
			try {
				return Ct(t)
			} catch (t) {
				return 'Object'
			}
		},
		St = J,
		kt = Ft,
		Dt = TypeError,
		xt = function (t) {
			if (St(t)) return t
			throw Dt(kt(t) + ' is not a function')
		},
		wt = xt,
		Ot = H,
		$t = function (t, e) {
			var n = t[e]
			return Ot(n) ? void 0 : wt(n)
		},
		Bt = y,
		jt = J,
		Tt = tt,
		Lt = TypeError,
		It = { exports: {} },
		Rt = f,
		_t = Object.defineProperty,
		Mt = function (t, e) {
			try {
				_t(Rt, t, { value: e, configurable: !0, writable: !0 })
			} catch (n) {
				Rt[t] = e
			}
			return e
		},
		Pt = Mt,
		Nt = '__core-js_shared__',
		Ht = f[Nt] || Pt(Nt, {}),
		Ut = Ht
	;(It.exports = function (t, e) {
		return Ut[t] || (Ut[t] = void 0 !== e ? e : {})
	})('versions', []).push({
		version: '3.30.2',
		mode: 'global',
		copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
		license: 'https://github.com/zloirock/core-js/blob/v3.30.2/LICENSE',
		source: 'https://github.com/zloirock/core-js',
	})
	var Gt = It.exports,
		Wt = W,
		zt = Object,
		Kt = function (t) {
			return zt(Wt(t))
		},
		Vt = Kt,
		qt = B({}.hasOwnProperty),
		Yt =
			Object.hasOwn ||
			function (t, e) {
				return qt(Vt(t), e)
			},
		Xt = B,
		Jt = 0,
		Zt = Math.random(),
		Qt = Xt((1).toString),
		te = function (t) {
			return 'Symbol(' + (void 0 === t ? '' : t) + ')_' + Qt(++Jt + Zt, 36)
		},
		ee = Gt,
		ne = Yt,
		ie = te,
		ue = vt,
		re = gt,
		oe = f.Symbol,
		se = ee('wks'),
		ae = re ? oe.for || oe : (oe && oe.withoutSetter) || ie,
		le = function (t) {
			return ne(se, t) || (se[t] = ue && ne(oe, t) ? oe[t] : ae('Symbol.' + t)), se[t]
		},
		ce = y,
		he = tt,
		fe = At,
		de = $t,
		pe = function (t, e) {
			var n, i
			if ('string' === e && jt((n = t.toString)) && !Tt((i = Bt(n, t)))) return i
			if (jt((n = t.valueOf)) && !Tt((i = Bt(n, t)))) return i
			if ('string' !== e && jt((n = t.toString)) && !Tt((i = Bt(n, t)))) return i
			throw Lt("Can't convert object to primitive value")
		},
		ve = TypeError,
		ge = le('toPrimitive'),
		Ee = function (t, e) {
			if (!he(t) || fe(t)) return t
			var n,
				i = de(t, ge)
			if (i) {
				if ((void 0 === e && (e = 'default'), (n = ce(i, t, e)), !he(n) || fe(n))) return n
				throw ve("Can't convert object to primitive value")
			}
			return void 0 === e && (e = 'number'), pe(t, e)
		},
		be = At,
		ye = function (t) {
			var e = Ee(t, 'string')
			return be(e) ? e : e + ''
		},
		me = tt,
		Ae = f.document,
		Ce = me(Ae) && me(Ae.createElement),
		Fe = function (t) {
			return Ce ? Ae.createElement(t) : {}
		},
		Se = Fe,
		ke =
			!v &&
			!p(function () {
				return (
					7 !=
					Object.defineProperty(Se('div'), 'a', {
						get: function () {
							return 7
						},
					}).a
				)
			}),
		De = v,
		xe = y,
		we = m,
		Oe = D,
		$e = V,
		Be = ye,
		je = Yt,
		Te = ke,
		Le = Object.getOwnPropertyDescriptor
	d.f = De
		? Le
		: function (t, e) {
				if (((t = $e(t)), (e = Be(e)), Te))
					try {
						return Le(t, e)
					} catch (t) {}
				if (je(t, e)) return Oe(!xe(we.f, t, e), t[e])
			}
	var Ie = {},
		Re =
			v &&
			p(function () {
				return 42 != Object.defineProperty(function () {}, 'prototype', { value: 42, writable: !1 }).prototype
			}),
		_e = tt,
		Me = String,
		Pe = TypeError,
		Ne = function (t) {
			if (_e(t)) return t
			throw Pe(Me(t) + ' is not an object')
		},
		He = v,
		Ue = ke,
		Ge = Re,
		We = Ne,
		ze = ye,
		Ke = TypeError,
		Ve = Object.defineProperty,
		qe = Object.getOwnPropertyDescriptor,
		Ye = 'enumerable',
		Xe = 'configurable',
		Je = 'writable'
	Ie.f = He
		? Ge
			? function (t, e, n) {
					if ((We(t), (e = ze(e)), We(n), 'function' == typeof t && 'prototype' === e && 'value' in n && Je in n && !n[Je])) {
						var i = qe(t, e)
						i && i[Je] && ((t[e] = n.value), (n = { configurable: Xe in n ? n[Xe] : i[Xe], enumerable: Ye in n ? n[Ye] : i[Ye], writable: !1 }))
					}
					return Ve(t, e, n)
				}
			: Ve
		: function (t, e, n) {
				if ((We(t), (e = ze(e)), We(n), Ue))
					try {
						return Ve(t, e, n)
					} catch (t) {}
				if ('get' in n || 'set' in n) throw Ke('Accessors not supported')
				return 'value' in n && (t[e] = n.value), t
			}
	var Ze = Ie,
		Qe = D,
		tn = v
			? function (t, e, n) {
					return Ze.f(t, e, Qe(1, n))
				}
			: function (t, e, n) {
					return (t[e] = n), t
				},
		en = { exports: {} },
		nn = v,
		un = Yt,
		rn = Function.prototype,
		on = nn && Object.getOwnPropertyDescriptor,
		sn = un(rn, 'name'),
		an = { EXISTS: sn, PROPER: sn && 'something' === function () {}.name, CONFIGURABLE: sn && (!nn || (nn && on(rn, 'name').configurable)) },
		ln = J,
		cn = Ht,
		hn = B(Function.toString)
	ln(cn.inspectSource) ||
		(cn.inspectSource = function (t) {
			return hn(t)
		})
	var fn,
		dn,
		pn,
		vn = cn.inspectSource,
		gn = J,
		En = f.WeakMap,
		bn = gn(En) && /native code/.test(String(En)),
		yn = te,
		mn = Gt('keys'),
		An = function (t) {
			return mn[t] || (mn[t] = yn(t))
		},
		Cn = {},
		Fn = bn,
		Sn = f,
		kn = tt,
		Dn = tn,
		xn = Yt,
		wn = Ht,
		On = An,
		$n = Cn,
		Bn = 'Object already initialized',
		jn = Sn.TypeError,
		Tn = Sn.WeakMap
	if (Fn || wn.state) {
		var Ln = wn.state || (wn.state = new Tn())
		;(Ln.get = Ln.get),
			(Ln.has = Ln.has),
			(Ln.set = Ln.set),
			(fn = function (t, e) {
				if (Ln.has(t)) throw jn(Bn)
				return (e.facade = t), Ln.set(t, e), e
			}),
			(dn = function (t) {
				return Ln.get(t) || {}
			}),
			(pn = function (t) {
				return Ln.has(t)
			})
	} else {
		var In = On('state')
		;($n[In] = !0),
			(fn = function (t, e) {
				if (xn(t, In)) throw jn(Bn)
				return (e.facade = t), Dn(t, In, e), e
			}),
			(dn = function (t) {
				return xn(t, In) ? t[In] : {}
			}),
			(pn = function (t) {
				return xn(t, In)
			})
	}
	var Rn = {
			set: fn,
			get: dn,
			has: pn,
			enforce: function (t) {
				return pn(t) ? dn(t) : fn(t, {})
			},
			getterFor: function (t) {
				return function (e) {
					var n
					if (!kn(e) || (n = dn(e)).type !== t) throw jn('Incompatible receiver, ' + t + ' required')
					return n
				}
			},
		},
		_n = B,
		Mn = p,
		Pn = J,
		Nn = Yt,
		Hn = v,
		Un = an.CONFIGURABLE,
		Gn = vn,
		Wn = Rn.enforce,
		zn = Rn.get,
		Kn = String,
		Vn = Object.defineProperty,
		qn = _n(''.slice),
		Yn = _n(''.replace),
		Xn = _n([].join),
		Jn =
			Hn &&
			!Mn(function () {
				return 8 !== Vn(function () {}, 'length', { value: 8 }).length
			}),
		Zn = String(String).split('String'),
		Qn = (en.exports = function (t, e, n) {
			'Symbol(' === qn(Kn(e), 0, 7) && (e = '[' + Yn(Kn(e), /^Symbol\(([^)]*)\)/, '$1') + ']'),
				n && n.getter && (e = 'get ' + e),
				n && n.setter && (e = 'set ' + e),
				(!Nn(t, 'name') || (Un && t.name !== e)) && (Hn ? Vn(t, 'name', { value: e, configurable: !0 }) : (t.name = e)),
				Jn && n && Nn(n, 'arity') && t.length !== n.arity && Vn(t, 'length', { value: n.arity })
			try {
				n && Nn(n, 'constructor') && n.constructor ? Hn && Vn(t, 'prototype', { writable: !1 }) : t.prototype && (t.prototype = void 0)
			} catch (t) {}
			var i = Wn(t)
			return Nn(i, 'source') || (i.source = Xn(Zn, 'string' == typeof e ? e : '')), t
		})
	Function.prototype.toString = Qn(function () {
		return (Pn(this) && zn(this).source) || Gn(this)
	}, 'toString')
	var ti = en.exports,
		ei = J,
		ni = Ie,
		ii = ti,
		ui = Mt,
		ri = function (t, e, n, i) {
			i || (i = {})
			var u = i.enumerable,
				r = void 0 !== i.name ? i.name : e
			if ((ei(n) && ii(n, r, i), i.global)) u ? (t[e] = n) : ui(e, n)
			else {
				try {
					i.unsafe ? t[e] && (u = !0) : delete t[e]
				} catch (t) {}
				u ? (t[e] = n) : ni.f(t, e, { value: n, enumerable: !1, configurable: !i.nonConfigurable, writable: !i.nonWritable })
			}
			return t
		},
		oi = {},
		si = Math.ceil,
		ai = Math.floor,
		li =
			Math.trunc ||
			function (t) {
				var e = +t
				return (e > 0 ? ai : si)(e)
			},
		ci = function (t) {
			var e = +t
			return e != e || 0 === e ? 0 : li(e)
		},
		hi = ci,
		fi = Math.max,
		di = Math.min,
		pi = function (t, e) {
			var n = hi(t)
			return n < 0 ? fi(n + e, 0) : di(n, e)
		},
		vi = ci,
		gi = Math.min,
		Ei = function (t) {
			return t > 0 ? gi(vi(t), 9007199254740991) : 0
		},
		bi = Ei,
		yi = function (t) {
			return bi(t.length)
		},
		mi = V,
		Ai = pi,
		Ci = yi,
		Fi = function (t) {
			return function (e, n, i) {
				var u,
					r = mi(e),
					o = Ci(r),
					s = Ai(i, o)
				if (t && n != n) {
					for (; o > s; ) if ((u = r[s++]) != u) return !0
				} else for (; o > s; s++) if ((t || s in r) && r[s] === n) return t || s || 0
				return !t && -1
			}
		},
		Si = { includes: Fi(!0), indexOf: Fi(!1) },
		ki = Yt,
		Di = V,
		xi = Si.indexOf,
		wi = Cn,
		Oi = B([].push),
		$i = function (t, e) {
			var n,
				i = Di(t),
				u = 0,
				r = []
			for (n in i) !ki(wi, n) && ki(i, n) && Oi(r, n)
			for (; e.length > u; ) ki(i, (n = e[u++])) && (~xi(r, n) || Oi(r, n))
			return r
		},
		Bi = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'],
		ji = $i,
		Ti = Bi.concat('length', 'prototype')
	oi.f =
		Object.getOwnPropertyNames ||
		function (t) {
			return ji(t, Ti)
		}
	var Li = {}
	Li.f = Object.getOwnPropertySymbols
	var Ii = it,
		Ri = oi,
		_i = Li,
		Mi = Ne,
		Pi = B([].concat),
		Ni =
			Ii('Reflect', 'ownKeys') ||
			function (t) {
				var e = Ri.f(Mi(t)),
					n = _i.f
				return n ? Pi(e, n(t)) : e
			},
		Hi = Yt,
		Ui = Ni,
		Gi = d,
		Wi = Ie,
		zi = p,
		Ki = J,
		Vi = /#|\.prototype\./,
		qi = function (t, e) {
			var n = Xi[Yi(t)]
			return n == Zi || (n != Ji && (Ki(e) ? zi(e) : !!e))
		},
		Yi = (qi.normalize = function (t) {
			return String(t).replace(Vi, '.').toLowerCase()
		}),
		Xi = (qi.data = {}),
		Ji = (qi.NATIVE = 'N'),
		Zi = (qi.POLYFILL = 'P'),
		Qi = qi,
		tu = f,
		eu = d.f,
		nu = tn,
		iu = ri,
		uu = Mt,
		ru = function (t, e, n) {
			for (var i = Ui(e), u = Wi.f, r = Gi.f, o = 0; o < i.length; o++) {
				var s = i[o]
				Hi(t, s) || (n && Hi(n, s)) || u(t, s, r(e, s))
			}
		},
		ou = Qi,
		su = function (t, e) {
			var n,
				i,
				u,
				r,
				o,
				s = t.target,
				a = t.global,
				l = t.stat
			if ((n = a ? tu : l ? tu[s] || uu(s, {}) : (tu[s] || {}).prototype))
				for (i in e) {
					if (((r = e[i]), (u = t.dontCallGetSet ? (o = eu(n, i)) && o.value : n[i]), !ou(a ? i : s + (l ? '.' : '#') + i, t.forced) && void 0 !== u)) {
						if (typeof r == typeof u) continue
						ru(r, u)
					}
					;(t.sham || (u && u.sham)) && nu(r, 'sham', !0), iu(n, i, r, t)
				}
		},
		au = {}
	au[le('toStringTag')] = 'z'
	var lu = '[object z]' === String(au),
		cu = lu,
		hu = J,
		fu = I,
		du = le('toStringTag'),
		pu = Object,
		vu =
			'Arguments' ==
			fu(
				(function () {
					return arguments
				})(),
			),
		gu = cu
			? fu
			: function (t) {
					var e, n, i
					return void 0 === t
						? 'Undefined'
						: null === t
							? 'Null'
							: 'string' ==
								  typeof (n = (function (t, e) {
										try {
											return t[e]
										} catch (t) {}
								  })((e = pu(t)), du))
								? n
								: vu
									? fu(e)
									: 'Object' == (i = fu(e)) && hu(e.callee)
										? 'Arguments'
										: i
				},
		Eu = gu,
		bu = String,
		yu = function (t) {
			if ('Symbol' === Eu(t)) throw TypeError('Cannot convert a Symbol value to a string')
			return bu(t)
		},
		mu = Ne,
		Au = function () {
			var t = mu(this),
				e = ''
			return (
				t.hasIndices && (e += 'd'),
				t.global && (e += 'g'),
				t.ignoreCase && (e += 'i'),
				t.multiline && (e += 'm'),
				t.dotAll && (e += 's'),
				t.unicode && (e += 'u'),
				t.unicodeSets && (e += 'v'),
				t.sticky && (e += 'y'),
				e
			)
		},
		Cu = p,
		Fu = f.RegExp,
		Su = Cu(function () {
			var t = Fu('a', 'y')
			return (t.lastIndex = 2), null != t.exec('abcd')
		}),
		ku =
			Su ||
			Cu(function () {
				return !Fu('a', 'y').sticky
			}),
		Du = {
			BROKEN_CARET:
				Su ||
				Cu(function () {
					var t = Fu('^r', 'gy')
					return (t.lastIndex = 2), null != t.exec('str')
				}),
			MISSED_STICKY: ku,
			UNSUPPORTED_Y: Su,
		},
		xu = {},
		wu = $i,
		Ou = Bi,
		$u =
			Object.keys ||
			function (t) {
				return wu(t, Ou)
			},
		Bu = v,
		ju = Re,
		Tu = Ie,
		Lu = Ne,
		Iu = V,
		Ru = $u
	xu.f =
		Bu && !ju
			? Object.defineProperties
			: function (t, e) {
					Lu(t)
					for (var n, i = Iu(e), u = Ru(e), r = u.length, o = 0; r > o; ) Tu.f(t, (n = u[o++]), i[n])
					return t
				}
	var _u,
		Mu = it('document', 'documentElement'),
		Pu = Ne,
		Nu = xu,
		Hu = Bi,
		Uu = Cn,
		Gu = Mu,
		Wu = Fe,
		zu = 'prototype',
		Ku = 'script',
		Vu = An('IE_PROTO'),
		qu = function () {},
		Yu = function (t) {
			return '<' + Ku + '>' + t + '</' + Ku + '>'
		},
		Xu = function (t) {
			t.write(Yu('')), t.close()
			var e = t.parentWindow.Object
			return (t = null), e
		},
		Ju = function () {
			try {
				_u = new ActiveXObject('htmlfile')
			} catch (t) {}
			var t, e, n
			Ju =
				'undefined' != typeof document
					? document.domain && _u
						? Xu(_u)
						: ((e = Wu('iframe')),
							(n = 'java' + Ku + ':'),
							(e.style.display = 'none'),
							Gu.appendChild(e),
							(e.src = String(n)),
							(t = e.contentWindow.document).open(),
							t.write(Yu('document.F=Object')),
							t.close(),
							t.F)
					: Xu(_u)
			for (var i = Hu.length; i--; ) delete Ju[zu][Hu[i]]
			return Ju()
		}
	Uu[Vu] = !0
	var Zu,
		Qu,
		tr =
			Object.create ||
			function (t, e) {
				var n
				return null !== t ? ((qu[zu] = Pu(t)), (n = new qu()), (qu[zu] = null), (n[Vu] = t)) : (n = Ju()), void 0 === e ? n : Nu.f(n, e)
			},
		er = p,
		nr = f.RegExp,
		ir = er(function () {
			var t = nr('.', 's')
			return !(t.dotAll && t.exec('\n') && 's' === t.flags)
		}),
		ur = p,
		rr = f.RegExp,
		or = ur(function () {
			var t = rr('(?<a>b)', 'g')
			return 'b' !== t.exec('b').groups.a || 'bc' !== 'b'.replace(t, '$<a>c')
		}),
		sr = y,
		ar = B,
		lr = yu,
		cr = Au,
		hr = Du,
		fr = tr,
		dr = Rn.get,
		pr = ir,
		vr = or,
		gr = Gt('native-string-replace', String.prototype.replace),
		Er = RegExp.prototype.exec,
		br = Er,
		yr = ar(''.charAt),
		mr = ar(''.indexOf),
		Ar = ar(''.replace),
		Cr = ar(''.slice),
		Fr = ((Qu = /b*/g), sr(Er, (Zu = /a/), 'a'), sr(Er, Qu, 'a'), 0 !== Zu.lastIndex || 0 !== Qu.lastIndex),
		Sr = hr.BROKEN_CARET,
		kr = void 0 !== /()??/.exec('')[1]
	;(Fr || kr || Sr || pr || vr) &&
		(br = function (t) {
			var e,
				n,
				i,
				u,
				r,
				o,
				s,
				a = this,
				l = dr(a),
				c = lr(t),
				h = l.raw
			if (h) return (h.lastIndex = a.lastIndex), (e = sr(br, h, c)), (a.lastIndex = h.lastIndex), e
			var f = l.groups,
				d = Sr && a.sticky,
				p = sr(cr, a),
				v = a.source,
				g = 0,
				E = c
			if (
				(d &&
					((p = Ar(p, 'y', '')),
					-1 === mr(p, 'g') && (p += 'g'),
					(E = Cr(c, a.lastIndex)),
					a.lastIndex > 0 && (!a.multiline || (a.multiline && '\n' !== yr(c, a.lastIndex - 1))) && ((v = '(?: ' + v + ')'), (E = ' ' + E), g++),
					(n = new RegExp('^(?:' + v + ')', p))),
				kr && (n = new RegExp('^' + v + '$(?!\\s)', p)),
				Fr && (i = a.lastIndex),
				(u = sr(Er, d ? n : a, E)),
				d
					? u
						? ((u.input = Cr(u.input, g)), (u[0] = Cr(u[0], g)), (u.index = a.lastIndex), (a.lastIndex += u[0].length))
						: (a.lastIndex = 0)
					: Fr && u && (a.lastIndex = a.global ? u.index + u[0].length : i),
				kr &&
					u &&
					u.length > 1 &&
					sr(gr, u[0], n, function () {
						for (r = 1; r < arguments.length - 2; r++) void 0 === arguments[r] && (u[r] = void 0)
					}),
				u && f)
			)
				for (u.groups = o = fr(null), r = 0; r < f.length; r++) o[(s = f[r])[0]] = u[s[1]]
			return u
		})
	var Dr = br
	su({ target: 'RegExp', proto: !0, forced: /./.exec !== Dr }, { exec: Dr })
	var xr = I,
		wr = B,
		Or = function (t) {
			if ('Function' === xr(t)) return wr(t)
		},
		$r = Or,
		Br = ri,
		jr = Dr,
		Tr = p,
		Lr = le,
		Ir = tn,
		Rr = Lr('species'),
		_r = RegExp.prototype,
		Mr = function (t, e, n, i) {
			var u = Lr(t),
				r = !Tr(function () {
					var e = {}
					return (
						(e[u] = function () {
							return 7
						}),
						7 != ''[t](e)
					)
				}),
				o =
					r &&
					!Tr(function () {
						var e = !1,
							n = /a/
						return (
							'split' === t &&
								(((n = {}).constructor = {}),
								(n.constructor[Rr] = function () {
									return n
								}),
								(n.flags = ''),
								(n[u] = /./[u])),
							(n.exec = function () {
								return (e = !0), null
							}),
							n[u](''),
							!e
						)
					})
			if (!r || !o || n) {
				var s = $r(/./[u]),
					a = e(u, ''[t], function (t, e, n, i, u) {
						var o = $r(t),
							a = e.exec
						return a === jr || a === _r.exec ? (r && !u ? { done: !0, value: s(e, n, i) } : { done: !0, value: o(n, e, i) }) : { done: !1 }
					})
				Br(String.prototype, t, a[0]), Br(_r, u, a[1])
			}
			i && Ir(_r[u], 'sham', !0)
		},
		Pr =
			Object.is ||
			function (t, e) {
				return t === e ? 0 !== t || 1 / t == 1 / e : t != t && e != e
			},
		Nr = y,
		Hr = Ne,
		Ur = J,
		Gr = I,
		Wr = Dr,
		zr = TypeError,
		Kr = function (t, e) {
			var n = t.exec
			if (Ur(n)) {
				var i = Nr(n, t, e)
				return null !== i && Hr(i), i
			}
			if ('RegExp' === Gr(t)) return Nr(Wr, t, e)
			throw zr('RegExp#exec called on incompatible receiver')
		},
		Vr = y,
		qr = Ne,
		Yr = H,
		Xr = W,
		Jr = Pr,
		Zr = yu,
		Qr = $t,
		to = Kr
	Mr('search', function (t, e, n) {
		return [
			function (e) {
				var n = Xr(this),
					i = Yr(e) ? void 0 : Qr(e, t)
				return i ? Vr(i, e, n) : new RegExp(e)[t](Zr(n))
			},
			function (t) {
				var i = qr(this),
					u = Zr(t),
					r = n(e, i, u)
				if (r.done) return r.value
				var o = i.lastIndex
				Jr(o, 0) || (i.lastIndex = 0)
				var s = to(i, u)
				return Jr(i.lastIndex, o) || (i.lastIndex = o), null === s ? -1 : s.index
			},
		]
	})
	var eo = le,
		no = tr,
		io = Ie.f,
		uo = eo('unscopables'),
		ro = Array.prototype
	null == ro[uo] && io(ro, uo, { configurable: !0, value: no(null) })
	var oo = function (t) {
			ro[uo][t] = !0
		},
		so = Si.includes,
		ao = oo
	su(
		{
			target: 'Array',
			proto: !0,
			forced: p(function () {
				return !Array(1).includes()
			}),
		},
		{
			includes: function (t) {
				return so(this, t, arguments.length > 1 ? arguments[1] : void 0)
			},
		},
	),
		ao('includes')
	var lo = tt,
		co = I,
		ho = le('match'),
		fo = function (t) {
			var e
			return lo(t) && (void 0 !== (e = t[ho]) ? !!e : 'RegExp' == co(t))
		},
		po = fo,
		vo = TypeError,
		go = le('match'),
		Eo = su,
		bo = function (t) {
			if (po(t)) throw vo("The method doesn't accept regular expressions")
			return t
		},
		yo = W,
		mo = yu,
		Ao = function (t) {
			var e = /./
			try {
				'/./'[t](e)
			} catch (n) {
				try {
					return (e[go] = !1), '/./'[t](e)
				} catch (t) {}
			}
			return !1
		},
		Co = B(''.indexOf)
	Eo(
		{ target: 'String', proto: !0, forced: !Ao('includes') },
		{
			includes: function (t) {
				return !!~Co(mo(yo(this)), mo(bo(t)), arguments.length > 1 ? arguments[1] : void 0)
			},
		},
	)
	var Fo = '\t\n\v\f\r                　\u2028\u2029\ufeff',
		So = W,
		ko = yu,
		Do = Fo,
		xo = B(''.replace),
		wo = RegExp('^[' + Do + ']+'),
		Oo = RegExp('(^|[^' + Do + '])[' + Do + ']+$'),
		$o = function (t) {
			return function (e) {
				var n = ko(So(e))
				return 1 & t && (n = xo(n, wo, '')), 2 & t && (n = xo(n, Oo, '$1')), n
			}
		},
		Bo = { start: $o(1), end: $o(2), trim: $o(3) },
		jo = an.PROPER,
		To = p,
		Lo = Fo,
		Io = Bo.trim
	su(
		{
			target: 'String',
			proto: !0,
			forced: (function (t) {
				return To(function () {
					return !!Lo[t]() || '​᠎' !== '​᠎'[t]() || (jo && Lo[t].name !== t)
				})
			})('trim'),
		},
		{
			trim: function () {
				return Io(this)
			},
		},
	)
	var Ro = I,
		_o =
			Array.isArray ||
			function (t) {
				return 'Array' == Ro(t)
			},
		Mo = TypeError,
		Po = ye,
		No = Ie,
		Ho = D,
		Uo = function (t, e, n) {
			var i = Po(e)
			i in t ? No.f(t, i, Ho(0, n)) : (t[i] = n)
		},
		Go = B,
		Wo = p,
		zo = J,
		Ko = gu,
		Vo = vn,
		qo = function () {},
		Yo = [],
		Xo = it('Reflect', 'construct'),
		Jo = /^\s*(?:class|function)\b/,
		Zo = Go(Jo.exec),
		Qo = !Jo.exec(qo),
		ts = function (t) {
			if (!zo(t)) return !1
			try {
				return Xo(qo, Yo, t), !0
			} catch (t) {
				return !1
			}
		},
		es = function (t) {
			if (!zo(t)) return !1
			switch (Ko(t)) {
				case 'AsyncFunction':
				case 'GeneratorFunction':
				case 'AsyncGeneratorFunction':
					return !1
			}
			try {
				return Qo || !!Zo(Jo, Vo(t))
			} catch (t) {
				return !0
			}
		}
	es.sham = !0
	var ns =
			!Xo ||
			Wo(function () {
				var t
				return (
					ts(ts.call) ||
					!ts(Object) ||
					!ts(function () {
						t = !0
					}) ||
					t
				)
			})
				? es
				: ts,
		is = _o,
		us = ns,
		rs = tt,
		os = le('species'),
		ss = Array,
		as = function (t) {
			var e
			return (
				is(t) && ((e = t.constructor), ((us(e) && (e === ss || is(e.prototype))) || (rs(e) && null === (e = e[os]))) && (e = void 0)), void 0 === e ? ss : e
			)
		},
		ls = function (t, e) {
			return new (as(t))(0 === e ? 0 : e)
		},
		cs = p,
		hs = ht,
		fs = le('species'),
		ds = function (t) {
			return (
				hs >= 51 ||
				!cs(function () {
					var e = []
					return (
						((e.constructor = {})[fs] = function () {
							return { foo: 1 }
						}),
						1 !== e[t](Boolean).foo
					)
				})
			)
		},
		ps = su,
		vs = p,
		gs = _o,
		Es = tt,
		bs = Kt,
		ys = yi,
		ms = function (t) {
			if (t > 9007199254740991) throw Mo('Maximum allowed index exceeded')
			return t
		},
		As = Uo,
		Cs = ls,
		Fs = ds,
		Ss = ht,
		ks = le('isConcatSpreadable'),
		Ds =
			Ss >= 51 ||
			!vs(function () {
				var t = []
				return (t[ks] = !1), t.concat()[0] !== t
			}),
		xs = function (t) {
			if (!Es(t)) return !1
			var e = t[ks]
			return void 0 !== e ? !!e : gs(t)
		}
	ps(
		{ target: 'Array', proto: !0, arity: 1, forced: !Ds || !Fs('concat') },
		{
			concat: function (t) {
				var e,
					n,
					i,
					u,
					r,
					o = bs(this),
					s = Cs(o, 0),
					a = 0
				for (e = -1, i = arguments.length; e < i; e++)
					if (xs((r = -1 === e ? o : arguments[e]))) for (u = ys(r), ms(a + u), n = 0; n < u; n++, a++) n in r && As(s, a, r[n])
					else ms(a + 1), As(s, a++, r)
				return (s.length = a), s
			},
		},
	)
	var ws = v,
		Os = B,
		$s = y,
		Bs = p,
		js = $u,
		Ts = Li,
		Ls = m,
		Is = Kt,
		Rs = N,
		_s = Object.assign,
		Ms = Object.defineProperty,
		Ps = Os([].concat),
		Ns =
			!_s ||
			Bs(function () {
				if (
					ws &&
					1 !==
						_s(
							{ b: 1 },
							_s(
								Ms({}, 'a', {
									enumerable: !0,
									get: function () {
										Ms(this, 'b', { value: 3, enumerable: !1 })
									},
								}),
								{ b: 2 },
							),
						).b
				)
					return !0
				var t = {},
					e = {},
					n = Symbol(),
					i = 'abcdefghijklmnopqrst'
				return (
					(t[n] = 7),
					i.split('').forEach(function (t) {
						e[t] = t
					}),
					7 != _s({}, t)[n] || js(_s({}, e)).join('') != i
				)
			})
				? function (t, e) {
						for (var n = Is(t), i = arguments.length, u = 1, r = Ts.f, o = Ls.f; i > u; )
							for (var s, a = Rs(arguments[u++]), l = r ? Ps(js(a), r(a)) : js(a), c = l.length, h = 0; c > h; )
								(s = l[h++]), (ws && !$s(o, a, s)) || (n[s] = a[s])
						return n
					}
				: _s,
		Hs = Ns
	su({ target: 'Object', stat: !0, arity: 2, forced: Object.assign !== Hs }, { assign: Hs })
	var Us = {
			name: '',
			placeholder: '',
			classes: '',
			classPrefix: '',
			data: void 0,
			locale: void 0,
			selectAll: !0,
			single: void 0,
			singleRadio: !1,
			multiple: !1,
			hideOptgroupCheckboxes: !1,
			multipleWidth: 80,
			width: void 0,
			size: void 0,
			dropWidth: void 0,
			maxHeight: 250,
			maxHeightUnit: 'px',
			position: 'bottom',
			displayValues: !1,
			displayTitle: !1,
			displayDelimiter: ', ',
			minimumCountSelected: 3,
			ellipsis: !1,
			isOpen: !1,
			keepOpen: !1,
			openOnHover: !1,
			container: null,
			filter: !1,
			filterGroup: !1,
			filterPlaceholder: '',
			filterAcceptOnEnter: !1,
			filterByDataLength: void 0,
			customFilter: function (t) {
				var e = t.text,
					n = t.label,
					i = t.search
				return (n || e).includes(i)
			},
			showClear: !1,
			animate: void 0,
			styler: function () {
				return !1
			},
			textTemplate: function (t) {
				return t[0].innerHTML.trim()
			},
			labelTemplate: function (t) {
				return t[0].getAttribute('label')
			},
			onOpen: function () {
				return !1
			},
			onClose: function () {
				return !1
			},
			onCheckAll: function () {
				return !1
			},
			onUncheckAll: function () {
				return !1
			},
			onFocus: function () {
				return !1
			},
			onBlur: function () {
				return !1
			},
			onOptgroupClick: function () {
				return !1
			},
			onBeforeClick: function () {
				return !0
			},
			onClick: function () {
				return !1
			},
			onFilter: function () {
				return !1
			},
			onClear: function () {
				return !1
			},
			onAfterCreate: function () {
				return !1
			},
		},
		Gs = {
			formatSelectAll: function () {
				return '[Select all]'
			},
			formatAllSelected: function () {
				return 'All selected'
			},
			formatCountSelected: function (t, e) {
				return ''.concat(t, ' of ').concat(e, ' selected')
			},
			formatNoMatchesFound: function () {
				return 'No matches found'
			},
		}
	Object.assign(Us, Gs)
	var Ws = {
			VERSION: '1.7.0',
			BLOCK_ROWS: 500,
			CLUSTER_BLOCKS: 4,
			DEFAULTS: Us,
			METHODS: [
				'getOptions',
				'refreshOptions',
				'getData',
				'getSelects',
				'setSelects',
				'enable',
				'disable',
				'open',
				'close',
				'check',
				'uncheck',
				'checkAll',
				'uncheckAll',
				'checkInvert',
				'focus',
				'blur',
				'refresh',
				'destroy',
			],
			LOCALES: { en: Gs, 'en-US': Gs },
		},
		zs = g,
		Ks = Function.prototype,
		Vs = Ks.apply,
		qs = Ks.call,
		Ys =
			('object' == typeof Reflect && Reflect.apply) ||
			(zs
				? qs.bind(Vs)
				: function () {
						return qs.apply(Vs, arguments)
					}),
		Xs = ns,
		Js = Ft,
		Zs = TypeError,
		Qs = Ne,
		ta = function (t) {
			if (Xs(t)) return t
			throw Zs(Js(t) + ' is not a constructor')
		},
		ea = H,
		na = le('species'),
		ia = B,
		ua = ci,
		ra = yu,
		oa = W,
		sa = ia(''.charAt),
		aa = ia(''.charCodeAt),
		la = ia(''.slice),
		ca = function (t) {
			return function (e, n) {
				var i,
					u,
					r = ra(oa(e)),
					o = ua(n),
					s = r.length
				return o < 0 || o >= s
					? t
						? ''
						: void 0
					: (i = aa(r, o)) < 55296 || i > 56319 || o + 1 === s || (u = aa(r, o + 1)) < 56320 || u > 57343
						? t
							? sa(r, o)
							: i
						: t
							? la(r, o, o + 2)
							: u - 56320 + ((i - 55296) << 10) + 65536
			}
		},
		ha = { codeAt: ca(!1), charAt: ca(!0) }.charAt,
		fa = function (t, e, n) {
			return e + (n ? ha(t, e).length : 1)
		},
		da = pi,
		pa = yi,
		va = Uo,
		ga = Array,
		Ea = Math.max,
		ba = Ys,
		ya = y,
		ma = B,
		Aa = Mr,
		Ca = Ne,
		Fa = H,
		Sa = fo,
		ka = W,
		Da = function (t, e) {
			var n,
				i = Qs(t).constructor
			return void 0 === i || ea((n = Qs(i)[na])) ? e : ta(n)
		},
		xa = fa,
		wa = Ei,
		Oa = yu,
		$a = $t,
		Ba = function (t, e, n) {
			for (var i = pa(t), u = da(e, i), r = da(void 0 === n ? i : n, i), o = ga(Ea(r - u, 0)), s = 0; u < r; u++, s++) va(o, s, t[u])
			return (o.length = s), o
		},
		ja = Kr,
		Ta = Dr,
		La = p,
		Ia = Du.UNSUPPORTED_Y,
		Ra = 4294967295,
		_a = Math.min,
		Ma = [].push,
		Pa = ma(/./.exec),
		Na = ma(Ma),
		Ha = ma(''.slice),
		Ua = !La(function () {
			var t = /(?:)/,
				e = t.exec
			t.exec = function () {
				return e.apply(this, arguments)
			}
			var n = 'ab'.split(t)
			return 2 !== n.length || 'a' !== n[0] || 'b' !== n[1]
		})
	Aa(
		'split',
		function (t, e, n) {
			var i
			return (
				(i =
					'c' == 'abbc'.split(/(b)*/)[1] ||
					4 != 'test'.split(/(?:)/, -1).length ||
					2 != 'ab'.split(/(?:ab)*/).length ||
					4 != '.'.split(/(.?)(.?)/).length ||
					'.'.split(/()()/).length > 1 ||
					''.split(/.?/).length
						? function (t, n) {
								var i = Oa(ka(this)),
									u = void 0 === n ? Ra : n >>> 0
								if (0 === u) return []
								if (void 0 === t) return [i]
								if (!Sa(t)) return ya(e, i, t, u)
								for (
									var r,
										o,
										s,
										a = [],
										l = (t.ignoreCase ? 'i' : '') + (t.multiline ? 'm' : '') + (t.unicode ? 'u' : '') + (t.sticky ? 'y' : ''),
										c = 0,
										h = new RegExp(t.source, l + 'g');
									(r = ya(Ta, h, i)) &&
									!(
										(o = h.lastIndex) > c &&
										(Na(a, Ha(i, c, r.index)), r.length > 1 && r.index < i.length && ba(Ma, a, Ba(r, 1)), (s = r[0].length), (c = o), a.length >= u)
									);

								)
									h.lastIndex === r.index && h.lastIndex++
								return c === i.length ? (!s && Pa(h, '')) || Na(a, '') : Na(a, Ha(i, c)), a.length > u ? Ba(a, 0, u) : a
							}
						: '0'.split(void 0, 0).length
							? function (t, n) {
									return void 0 === t && 0 === n ? [] : ya(e, this, t, n)
								}
							: e),
				[
					function (e, n) {
						var u = ka(this),
							r = Fa(e) ? void 0 : $a(e, t)
						return r ? ya(r, e, u, n) : ya(i, Oa(u), e, n)
					},
					function (t, u) {
						var r = Ca(this),
							o = Oa(t),
							s = n(i, r, o, u, i !== e)
						if (s.done) return s.value
						var a = Da(r, RegExp),
							l = r.unicode,
							c = (r.ignoreCase ? 'i' : '') + (r.multiline ? 'm' : '') + (r.unicode ? 'u' : '') + (Ia ? 'g' : 'y'),
							h = new a(Ia ? '^(?:' + r.source + ')' : r, c),
							f = void 0 === u ? Ra : u >>> 0
						if (0 === f) return []
						if (0 === o.length) return null === ja(h, o) ? [o] : []
						for (var d = 0, p = 0, v = []; p < o.length; ) {
							h.lastIndex = Ia ? 0 : p
							var g,
								E = ja(h, Ia ? Ha(o, p) : o)
							if (null === E || (g = _a(wa(h.lastIndex + (Ia ? p : 0)), o.length)) === d) p = xa(o, p, l)
							else {
								if ((Na(v, Ha(o, d, p)), v.length === f)) return v
								for (var b = 1; b <= E.length - 1; b++) if ((Na(v, E[b]), v.length === f)) return v
								p = d = g
							}
						}
						return Na(v, Ha(o, d)), v
					},
				]
			)
		},
		!Ua,
		Ia,
	)
	var Ga = p,
		Wa = function (t, e) {
			var n = [][t]
			return (
				!!n &&
				Ga(function () {
					n.call(
						null,
						e ||
							function () {
								return 1
							},
						1,
					)
				})
			)
		},
		za = su,
		Ka = N,
		Va = V,
		qa = Wa,
		Ya = B([].join)
	za(
		{ target: 'Array', proto: !0, forced: Ka != Object || !qa('join', ',') },
		{
			join: function (t) {
				return Ya(Va(this), void 0 === t ? ',' : t)
			},
		},
	)
	var Xa = ti,
		Ja = Ie,
		Za = v,
		Qa = an.EXISTS,
		tl = B,
		el = function (t, e, n) {
			return n.get && Xa(n.get, e, { getter: !0 }), n.set && Xa(n.set, e, { setter: !0 }), Ja.f(t, e, n)
		},
		nl = Function.prototype,
		il = tl(nl.toString),
		ul = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/,
		rl = tl(ul.exec)
	Za &&
		!Qa &&
		el(nl, 'name', {
			configurable: !0,
			get: function () {
				try {
					return rl(ul, il(this))[1]
				} catch (t) {
					return ''
				}
			},
		})
	var ol = xt,
		sl = g,
		al = Or(Or.bind),
		ll = function (t, e) {
			return (
				ol(t),
				void 0 === e
					? t
					: sl
						? al(t, e)
						: function () {
								return t.apply(e, arguments)
							}
			)
		},
		cl = N,
		hl = Kt,
		fl = yi,
		dl = ls,
		pl = B([].push),
		vl = function (t) {
			var e = 1 == t,
				n = 2 == t,
				i = 3 == t,
				u = 4 == t,
				r = 6 == t,
				o = 7 == t,
				s = 5 == t || r
			return function (a, l, c, h) {
				for (var f, d, p = hl(a), v = cl(p), g = ll(l, c), E = fl(v), b = 0, y = h || dl, m = e ? y(a, E) : n || o ? y(a, 0) : void 0; E > b; b++)
					if ((s || b in v) && ((d = g((f = v[b]), b, p)), t))
						if (e) m[b] = d
						else if (d)
							switch (t) {
								case 3:
									return !0
								case 5:
									return f
								case 6:
									return b
								case 2:
									pl(m, f)
							}
						else
							switch (t) {
								case 4:
									return !1
								case 7:
									pl(m, f)
							}
				return r ? -1 : i || u ? u : m
			}
		},
		gl = { forEach: vl(0), map: vl(1), filter: vl(2), some: vl(3), every: vl(4), find: vl(5), findIndex: vl(6), filterReject: vl(7) },
		El = su,
		bl = gl.find,
		yl = oo,
		ml = 'find',
		Al = !0
	ml in [] &&
		Array(1)[ml](function () {
			Al = !1
		}),
		El(
			{ target: 'Array', proto: !0, forced: Al },
			{
				find: function (t) {
					return bl(this, t, arguments.length > 1 ? arguments[1] : void 0)
				},
			},
		),
		yl(ml)
	var Cl = gu,
		Fl = lu
			? {}.toString
			: function () {
					return '[object ' + Cl(this) + ']'
				}
	lu || ri(Object.prototype, 'toString', Fl, { unsafe: !0 })
	var Sl = gl.map
	su(
		{ target: 'Array', proto: !0, forced: !ds('map') },
		{
			map: function (t) {
				return Sl(this, t, arguments.length > 1 ? arguments[1] : void 0)
			},
		},
	)
	var kl = v,
		Dl = B,
		xl = $u,
		wl = V,
		Ol = Dl(m.f),
		$l = Dl([].push),
		Bl = function (t) {
			return function (e) {
				for (var n, i = wl(e), u = xl(i), r = u.length, o = 0, s = []; r > o; ) (n = u[o++]), (kl && !Ol(i, n)) || $l(s, t ? [n, i[n]] : i[n])
				return s
			}
		},
		jl = { entries: Bl(!0), values: Bl(!1) }.entries
	su(
		{ target: 'Object', stat: !0 },
		{
			entries: function (t) {
				return jl(t)
			},
		},
	)
	var Tl = Kt,
		Ll = $u
	su(
		{
			target: 'Object',
			stat: !0,
			forced: p(function () {
				Ll(1)
			}),
		},
		{
			keys: function (t) {
				return Ll(Tl(t))
			},
		},
	)
	var Il = gl.filter
	su(
		{ target: 'Array', proto: !0, forced: !ds('filter') },
		{
			filter: function (t) {
				return Il(this, t, arguments.length > 1 ? arguments[1] : void 0)
			},
		},
	)
	var Rl = Fe('span').classList,
		_l = Rl && Rl.constructor && Rl.constructor.prototype,
		Ml = _l === Object.prototype ? void 0 : _l,
		Pl = gl.forEach,
		Nl = Wa('forEach')
			? [].forEach
			: function (t) {
					return Pl(this, t, arguments.length > 1 ? arguments[1] : void 0)
				},
		Hl = f,
		Ul = {
			CSSRuleList: 0,
			CSSStyleDeclaration: 0,
			CSSValueList: 0,
			ClientRectList: 0,
			DOMRectList: 0,
			DOMStringList: 0,
			DOMTokenList: 1,
			DataTransferItemList: 0,
			FileList: 0,
			HTMLAllCollection: 0,
			HTMLCollection: 0,
			HTMLFormElement: 0,
			HTMLSelectElement: 0,
			MediaList: 0,
			MimeTypeArray: 0,
			NamedNodeMap: 0,
			NodeList: 1,
			PaintRequestList: 0,
			Plugin: 0,
			PluginArray: 0,
			SVGLengthList: 0,
			SVGNumberList: 0,
			SVGPathSegList: 0,
			SVGPointList: 0,
			SVGStringList: 0,
			SVGTransformList: 0,
			SourceBufferList: 0,
			StyleSheetList: 0,
			TextTrackCueList: 0,
			TextTrackList: 0,
			TouchList: 0,
		},
		Gl = Ml,
		Wl = Nl,
		zl = tn,
		Kl = function (t) {
			if (t && t.forEach !== Wl)
				try {
					zl(t, 'forEach', Wl)
				} catch (e) {
					t.forEach = Wl
				}
		}
	for (var Vl in Ul) Ul[Vl] && Kl(Hl[Vl] && Hl[Vl].prototype)
	Kl(Gl)
	var ql = B([].slice),
		Yl = su,
		Xl = _o,
		Jl = ns,
		Zl = tt,
		Ql = pi,
		tc = yi,
		ec = V,
		nc = Uo,
		ic = le,
		uc = ql,
		rc = ds('slice'),
		oc = ic('species'),
		sc = Array,
		ac = Math.max
	Yl(
		{ target: 'Array', proto: !0, forced: !rc },
		{
			slice: function (t, e) {
				var n,
					i,
					u,
					r = ec(this),
					o = tc(r),
					s = Ql(t, o),
					a = Ql(void 0 === e ? o : e, o)
				if (
					Xl(r) &&
					((n = r.constructor), ((Jl(n) && (n === sc || Xl(n.prototype))) || (Zl(n) && null === (n = n[oc]))) && (n = void 0), n === sc || void 0 === n)
				)
					return uc(r, s, a)
				for (i = new (void 0 === n ? sc : n)(ac(a - s, 0)), u = 0; s < a; s++, u++) s in r && nc(i, u, r[s])
				return (i.length = u), i
			},
		},
	)
	var lc = y,
		cc = Yt,
		hc = ut,
		fc = Au,
		dc = RegExp.prototype,
		pc = an.PROPER,
		vc = ri,
		gc = Ne,
		Ec = yu,
		bc = p,
		yc = function (t) {
			var e = t.flags
			return void 0 !== e || 'flags' in dc || cc(t, 'flags') || !hc(dc, t) ? e : lc(fc, t)
		},
		mc = 'toString',
		Ac = RegExp.prototype[mc],
		Cc = bc(function () {
			return '/a/b' != Ac.call({ source: 'a', flags: 'b' })
		}),
		Fc = pc && Ac.name != mc
	;(Cc || Fc) &&
		vc(
			RegExp.prototype,
			mc,
			function () {
				var t = gc(this)
				return '/' + Ec(t.source) + '/' + Ec(yc(t))
			},
			{ unsafe: !0 },
		)
	var Sc = (function () {
			function t(e) {
				var i = this
				n(this, t),
					(this.rows = e.rows),
					(this.scrollEl = e.scrollEl),
					(this.contentEl = e.contentEl),
					(this.callback = e.callback),
					(this.cache = {}),
					(this.scrollTop = this.scrollEl.scrollTop),
					this.initDOM(this.rows),
					(this.scrollEl.scrollTop = this.scrollTop),
					(this.lastCluster = 0)
				var u = function () {
					i.lastCluster !== (i.lastCluster = i.getNum()) && (i.initDOM(i.rows), i.callback())
				}
				this.scrollEl.addEventListener('scroll', u, !1),
					(this.destroy = function () {
						;(i.contentEl.innerHtml = ''), i.scrollEl.removeEventListener('scroll', u, !1)
					})
			}
			return (
				u(t, [
					{
						key: 'initDOM',
						value: function (t) {
							void 0 === this.clusterHeight &&
								((this.cache.scrollTop = this.scrollEl.scrollTop), (this.cache.data = this.contentEl.innerHTML = t[0] + t[0] + t[0]), this.getRowsHeight(t))
							var e = this.initData(t, this.getNum()),
								n = e.rows.join(''),
								i = this.checkChanges('data', n),
								u = this.checkChanges('top', e.topOffset),
								r = this.checkChanges('bottom', e.bottomOffset),
								o = []
							i && u
								? (e.topOffset && o.push(this.getExtra('top', e.topOffset)),
									o.push(n),
									e.bottomOffset && o.push(this.getExtra('bottom', e.bottomOffset)),
									(this.contentEl.innerHTML = o.join('')))
								: r && (this.contentEl.lastChild.style.height = ''.concat(e.bottomOffset, 'px'))
						},
					},
					{
						key: 'getRowsHeight',
						value: function () {
							if (void 0 === this.itemHeight) {
								var t = this.contentEl.children,
									e = t[Math.floor(t.length / 2)]
								this.itemHeight = e.offsetHeight
							}
							;(this.blockHeight = this.itemHeight * Ws.BLOCK_ROWS),
								(this.clusterRows = Ws.BLOCK_ROWS * Ws.CLUSTER_BLOCKS),
								(this.clusterHeight = this.blockHeight * Ws.CLUSTER_BLOCKS)
						},
					},
					{
						key: 'getNum',
						value: function () {
							return (this.scrollTop = this.scrollEl.scrollTop), Math.floor(this.scrollTop / (this.clusterHeight - this.blockHeight)) || 0
						},
					},
					{
						key: 'initData',
						value: function (t, e) {
							if (t.length < Ws.BLOCK_ROWS) return { topOffset: 0, bottomOffset: 0, rowsAbove: 0, rows: t }
							var n = Math.max((this.clusterRows - Ws.BLOCK_ROWS) * e, 0),
								i = n + this.clusterRows,
								u = Math.max(n * this.itemHeight, 0),
								r = Math.max((t.length - i) * this.itemHeight, 0),
								o = [],
								s = n
							u < 1 && s++
							for (var a = n; a < i; a++) t[a] && o.push(t[a])
							return (this.dataStart = n), (this.dataEnd = i), { topOffset: u, bottomOffset: r, rowsAbove: s, rows: o }
						},
					},
					{
						key: 'checkChanges',
						value: function (t, e) {
							var n = e !== this.cache[t]
							return (this.cache[t] = e), n
						},
					},
					{
						key: 'getExtra',
						value: function (t, e) {
							var n = document.createElement('li')
							return (n.className = 'virtual-scroll-'.concat(t)), e && (n.style.height = ''.concat(e, 'px')), n.outerHTML
						},
					},
				]),
				t
			)
		})(),
		kc = B,
		Dc = Kt,
		xc = Math.floor,
		wc = kc(''.charAt),
		Oc = kc(''.replace),
		$c = kc(''.slice),
		Bc = /\$([$&'`]|\d{1,2}|<[^>]*>)/g,
		jc = /\$([$&'`]|\d{1,2})/g,
		Tc = Ys,
		Lc = y,
		Ic = B,
		Rc = Mr,
		_c = p,
		Mc = Ne,
		Pc = J,
		Nc = H,
		Hc = ci,
		Uc = Ei,
		Gc = yu,
		Wc = W,
		zc = fa,
		Kc = $t,
		Vc = function (t, e, n, i, u, r) {
			var o = n + t.length,
				s = i.length,
				a = jc
			return (
				void 0 !== u && ((u = Dc(u)), (a = Bc)),
				Oc(r, a, function (r, a) {
					var l
					switch (wc(a, 0)) {
						case '$':
							return '$'
						case '&':
							return t
						case '`':
							return $c(e, 0, n)
						case "'":
							return $c(e, o)
						case '<':
							l = u[$c(a, 1, -1)]
							break
						default:
							var c = +a
							if (0 === c) return r
							if (c > s) {
								var h = xc(c / 10)
								return 0 === h ? r : h <= s ? (void 0 === i[h - 1] ? wc(a, 1) : i[h - 1] + wc(a, 1)) : r
							}
							l = i[c - 1]
					}
					return void 0 === l ? '' : l
				})
			)
		},
		qc = Kr,
		Yc = le('replace'),
		Xc = Math.max,
		Jc = Math.min,
		Zc = Ic([].concat),
		Qc = Ic([].push),
		th = Ic(''.indexOf),
		eh = Ic(''.slice),
		nh = '$0' === 'a'.replace(/./, '$0'),
		ih = !!/./[Yc] && '' === /./[Yc]('a', '$0')
	Rc(
		'replace',
		function (t, e, n) {
			var i = ih ? '$' : '$0'
			return [
				function (t, n) {
					var i = Wc(this),
						u = Nc(t) ? void 0 : Kc(t, Yc)
					return u ? Lc(u, t, i, n) : Lc(e, Gc(i), t, n)
				},
				function (t, u) {
					var r = Mc(this),
						o = Gc(t)
					if ('string' == typeof u && -1 === th(u, i) && -1 === th(u, '$<')) {
						var s = n(e, r, o, u)
						if (s.done) return s.value
					}
					var a = Pc(u)
					a || (u = Gc(u))
					var l = r.global
					if (l) {
						var c = r.unicode
						r.lastIndex = 0
					}
					for (var h = []; ; ) {
						var f = qc(r, o)
						if (null === f) break
						if ((Qc(h, f), !l)) break
						'' === Gc(f[0]) && (r.lastIndex = zc(o, Uc(r.lastIndex), c))
					}
					for (var d, p = '', v = 0, g = 0; g < h.length; g++) {
						for (var E = Gc((f = h[g])[0]), b = Xc(Jc(Hc(f.index), o.length), 0), y = [], m = 1; m < f.length; m++) Qc(y, void 0 === (d = f[m]) ? d : String(d))
						var A = f.groups
						if (a) {
							var C = Zc([E], y, b, o)
							void 0 !== A && Qc(C, A)
							var F = Gc(Tc(u, void 0, C))
						} else F = Vc(E, o, b, y, A, u)
						b >= v && ((p += eh(o, v, b) + F), (v = b + E.length))
					}
					return p + eh(o, v)
				},
			]
		},
		!!_c(function () {
			var t = /./
			return (
				(t.exec = function () {
					var t = []
					return (t.groups = { a: '7' }), t
				}),
				'7' !== ''.replace(t, '$<a>')
			)
		}) ||
			!nh ||
			ih,
	)
	var uh = xt,
		rh = Kt,
		oh = N,
		sh = yi,
		ah = TypeError,
		lh = function (t) {
			return function (e, n, i, u) {
				uh(n)
				var r = rh(e),
					o = oh(r),
					s = sh(r),
					a = t ? s - 1 : 0,
					l = t ? -1 : 1
				if (i < 2)
					for (;;) {
						if (a in o) {
							;(u = o[a]), (a += l)
							break
						}
						if (((a += l), t ? a < 0 : s <= a)) throw ah('Reduce of empty array with no initial value')
					}
				for (; t ? a >= 0 : s > a; a += l) a in o && (u = n(u, o[a], a, r))
				return u
			}
		},
		ch = { left: lh(!1), right: lh(!0) },
		hh = 'undefined' != typeof process && 'process' == I(process),
		fh = ch.left
	su(
		{ target: 'Array', proto: !0, forced: (!hh && ht > 79 && ht < 83) || !Wa('reduce') },
		{
			reduce: function (t) {
				var e = arguments.length
				return fh(this, t, e, e > 1 ? arguments[1] : void 0)
			},
		},
	)
	var dh = function (t) {
			if (t.normalize) return t.normalize('NFD').replace(/[\u0300-\u036F]/g, '')
			return [
				{
					base: 'A',
					letters:
						/[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g,
				},
				{ base: 'AA', letters: /[\uA732]/g },
				{ base: 'AE', letters: /[\u00C6\u01FC\u01E2]/g },
				{ base: 'AO', letters: /[\uA734]/g },
				{ base: 'AU', letters: /[\uA736]/g },
				{ base: 'AV', letters: /[\uA738\uA73A]/g },
				{ base: 'AY', letters: /[\uA73C]/g },
				{ base: 'B', letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g },
				{ base: 'C', letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g },
				{ base: 'D', letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g },
				{ base: 'DZ', letters: /[\u01F1\u01C4]/g },
				{ base: 'Dz', letters: /[\u01F2\u01C5]/g },
				{
					base: 'E',
					letters:
						/[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g,
				},
				{ base: 'F', letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g },
				{ base: 'G', letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g },
				{ base: 'H', letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g },
				{ base: 'I', letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g },
				{ base: 'J', letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g },
				{ base: 'K', letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g },
				{ base: 'L', letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g },
				{ base: 'LJ', letters: /[\u01C7]/g },
				{ base: 'Lj', letters: /[\u01C8]/g },
				{ base: 'M', letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g },
				{ base: 'N', letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g },
				{ base: 'NJ', letters: /[\u01CA]/g },
				{ base: 'Nj', letters: /[\u01CB]/g },
				{
					base: 'O',
					letters:
						/[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g,
				},
				{ base: 'OI', letters: /[\u01A2]/g },
				{ base: 'OO', letters: /[\uA74E]/g },
				{ base: 'OU', letters: /[\u0222]/g },
				{ base: 'P', letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g },
				{ base: 'Q', letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g },
				{ base: 'R', letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g },
				{ base: 'S', letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g },
				{ base: 'T', letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g },
				{ base: 'TZ', letters: /[\uA728]/g },
				{
					base: 'U',
					letters:
						/[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g,
				},
				{ base: 'V', letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g },
				{ base: 'VY', letters: /[\uA760]/g },
				{ base: 'W', letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g },
				{ base: 'X', letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g },
				{ base: 'Y', letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g },
				{ base: 'Z', letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g },
				{
					base: 'a',
					letters:
						/[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g,
				},
				{ base: 'aa', letters: /[\uA733]/g },
				{ base: 'ae', letters: /[\u00E6\u01FD\u01E3]/g },
				{ base: 'ao', letters: /[\uA735]/g },
				{ base: 'au', letters: /[\uA737]/g },
				{ base: 'av', letters: /[\uA739\uA73B]/g },
				{ base: 'ay', letters: /[\uA73D]/g },
				{ base: 'b', letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g },
				{ base: 'c', letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g },
				{ base: 'd', letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g },
				{ base: 'dz', letters: /[\u01F3\u01C6]/g },
				{
					base: 'e',
					letters:
						/[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g,
				},
				{ base: 'f', letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g },
				{ base: 'g', letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g },
				{ base: 'h', letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g },
				{ base: 'hv', letters: /[\u0195]/g },
				{ base: 'i', letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g },
				{ base: 'j', letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g },
				{ base: 'k', letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g },
				{ base: 'l', letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g },
				{ base: 'lj', letters: /[\u01C9]/g },
				{ base: 'm', letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g },
				{ base: 'n', letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g },
				{ base: 'nj', letters: /[\u01CC]/g },
				{
					base: 'o',
					letters:
						/[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g,
				},
				{ base: 'oi', letters: /[\u01A3]/g },
				{ base: 'ou', letters: /[\u0223]/g },
				{ base: 'oo', letters: /[\uA74F]/g },
				{ base: 'p', letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g },
				{ base: 'q', letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g },
				{ base: 'r', letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g },
				{ base: 's', letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g },
				{ base: 't', letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g },
				{ base: 'tz', letters: /[\uA729]/g },
				{
					base: 'u',
					letters:
						/[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g,
				},
				{ base: 'v', letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g },
				{ base: 'vy', letters: /[\uA761]/g },
				{ base: 'w', letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g },
				{ base: 'x', letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g },
				{ base: 'y', letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g },
				{ base: 'z', letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g },
			].reduce(function (t, e) {
				var n = e.letters,
					i = e.base
				return t.replace(n, i)
			}, t)
		},
		ph = function (t, e, n) {
			var i,
				u = l(t)
			try {
				for (u.s(); !(i = u.n()).done; ) {
					var r = i.value
					if (r[e] === n || (r[e] === ''.concat(+r[e]) && +r[e] === n)) return r
					if ('optgroup' === r.type) {
						var o,
							s = l(r.children)
						try {
							for (s.s(); !(o = s.n()).done; ) {
								var a = o.value
								if (a[e] === n || (a[e] === ''.concat(+a[e]) && +a[e] === n)) return a
							}
						} catch (t) {
							s.e(t)
						} finally {
							s.f()
						}
					}
				}
			} catch (t) {
				u.e(t)
			} finally {
				u.f()
			}
		},
		vh = function (t) {
			return (
				Object.keys(t).forEach(function (e) {
					return void 0 === t[e] ? delete t[e] : ''
				}),
				t
			)
		},
		gh = (function () {
			function i(e, u) {
				n(this, i), (this.$el = e), (this.options = t.extend({}, Ws.DEFAULTS, u))
			}
			return (
				u(i, [
					{
						key: 'init',
						value: function () {
							this.initLocale(),
								this.initContainer(),
								this.initData(),
								this.initSelected(!0),
								this.initFilter(),
								this.initDrop(),
								this.initView(),
								this.options.onAfterCreate()
						},
					},
					{
						key: 'initLocale',
						value: function () {
							if (this.options.locale) {
								var e = t.fn.multipleSelect.locales,
									n = this.options.locale.split(/-|_/)
								;(n[0] = n[0].toLowerCase()),
									n[1] && (n[1] = n[1].toUpperCase()),
									e[this.options.locale]
										? t.extend(this.options, e[this.options.locale])
										: e[n.join('-')]
											? t.extend(this.options, e[n.join('-')])
											: e[n[0]] && t.extend(this.options, e[n[0]])
							}
						},
					},
					{
						key: 'initContainer',
						value: function () {
							var e = this,
								n = this.$el[0],
								i = n.getAttribute('name') || this.options.name || ''
							this.options.classes && this.$el.addClass(this.options.classes),
								this.options.classPrefix &&
									(this.$el.addClass(this.options.classPrefix),
									this.options.size && this.$el.addClass(''.concat(this.options.classPrefix, '-').concat(this.options.size))),
								this.$el.hide(),
								(this.$label = this.$el.closest('label')),
								!this.$label.length && this.$el.attr('id') && (this.$label = t('label[for="'.concat(this.$el.attr('id'), '"]'))),
								this.$label.find('>input').length && (this.$label = null),
								void 0 === this.options.single && (this.options.single = null === n.getAttribute('multiple')),
								(this.$parent = t(
									'\n      <div class="ms-parent '
										.concat(n.getAttribute('class') || '', ' ')
										.concat(this.options.classes, '"\n      title="')
										.concat(n.getAttribute('title') || '', '" />\n    '),
								)),
								(this.options.placeholder = this.options.placeholder || n.getAttribute('placeholder') || ''),
								(this.tabIndex = n.getAttribute('tabindex'))
							var u = ''
							if (
								(null !== this.tabIndex && (u = this.tabIndex && 'tabindex="'.concat(this.tabIndex, '"')),
								this.$el.attr('tabindex', -1),
								(this.$choice = t(
									'\n      <button type="button" class="ms-choice"'
										.concat(u, '>\n      <span class="placeholder">')
										.concat(this.options.placeholder, '</span>\n      ')
										.concat(this.options.showClear ? '<div class="icon-close"></div>' : '', '\n      <div class="icon-caret"></div>\n      </button>\n    '),
								)),
								(this.$drop = t('<div class="ms-drop '.concat(this.options.position, '" />'))),
								(this.$close = this.$choice.find('.icon-close')),
								this.options.dropWidth && this.$drop.css('width', this.options.dropWidth),
								this.$el.after(this.$parent),
								this.$parent.append(this.$choice),
								this.$parent.append(this.$drop),
								n.disabled && this.$choice.addClass('disabled'),
								(this.selectAllName = 'data-name="selectAll'.concat(i, '"')),
								(this.selectGroupName = 'data-name="selectGroup'.concat(i, '"')),
								(this.selectItemName = 'data-name="selectItem'.concat(i, '"')),
								!this.options.keepOpen)
							) {
								var r = (function () {
									var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ''
									return (t = t || ''.concat(+new Date()).concat(~~(1e6 * Math.random()))), 'click.multiple-select-'.concat(t)
								})(this.$el.attr('id'))
								t(document)
									.off(r)
									.on(r, function (i) {
										t(i.target)[0] !== e.$choice[0] &&
											t(i.target).parents('.ms-choice')[0] !== e.$choice[0] &&
											(t(i.target)[0] === e.$drop[0] || (t(i.target).parents('.ms-drop')[0] !== e.$drop[0] && i.target !== n)) &&
											e.options.isOpen &&
											e.close()
									})
							}
						},
					},
					{
						key: 'initData',
						value: function () {
							var n = this,
								i = []
							if (this.options.data) {
								if (Array.isArray(this.options.data))
									this.data = this.options.data.map(function (t) {
										return 'string' == typeof t || 'number' == typeof t ? { text: t, value: t } : t
									})
								else if ('object' === e(this.options.data)) {
									for (var u = 0, o = Object.entries(this.options.data); u < o.length; u++) {
										var s = r(o[u], 2),
											a = s[0],
											l = s[1]
										i.push({ value: a, text: l })
									}
									this.data = i
								}
							} else
								t.each(this.$el.children(), function (t, e) {
									n.initRow(t, e) && i.push(n.initRow(t, e))
								}),
									(this.options.data = i),
									(this.data = i),
									(this.fromHtml = !0)
							this.dataTotal = (function (t) {
								var e = 0
								return (
									t.forEach(function (t, n) {
										'optgroup' === t.type
											? ((t._key = 'group_'.concat(n)),
												(t.visible = void 0 === t.visible || t.visible),
												t.children.forEach(function (t, i) {
													;(t.visible = void 0 === t.visible || t.visible), t.divider || ((t._key = 'option_'.concat(n, '_').concat(i)), (e += 1))
												}))
											: ((t.visible = void 0 === t.visible || t.visible), t.divider || ((t._key = 'option_'.concat(n)), (e += 1)))
									}),
									e
								)
							})(this.data)
						},
					},
					{
						key: 'initRow',
						value: function (e, n, i) {
							var u = this,
								r = {},
								o = t(n)
							return o.is('option')
								? ((r.type = 'option'),
									(r.text = this.options.textTemplate(o)),
									(r.value = n.value),
									(r.visible = !0),
									(r.selected = !!n.selected),
									(r.disabled = i || n.disabled),
									(r.classes = n.getAttribute('class') || ''),
									(r.title = n.getAttribute('title') || ''),
									o.data('value') && (r._value = o.data('value')),
									Object.keys(o.data()).length && ((r._data = o.data()), r._data.divider && (r.divider = r._data.divider)),
									r)
								: o.is('optgroup')
									? ((r.type = 'optgroup'),
										(r.label = this.options.labelTemplate(o)),
										(r.visible = !0),
										(r.selected = !!n.selected),
										(r.disabled = n.disabled),
										(r.children = []),
										Object.keys(o.data()).length && (r._data = o.data()),
										t.each(o.children(), function (t, e) {
											r.children.push(u.initRow(t, e, r.disabled))
										}),
										r)
									: null
						},
					},
					{
						key: 'initSelected',
						value: function (t) {
							var e,
								n = 0,
								i = l(this.data)
							try {
								for (i.s(); !(e = i.n()).done; ) {
									var u = e.value
									if ('optgroup' === u.type) {
										var r = u.children.filter(function (t) {
											return t.selected && !t.disabled && t.visible
										}).length
										u.children.length &&
											(u.selected =
												!this.options.single &&
												r &&
												r ===
													u.children.filter(function (t) {
														return !t.disabled && t.visible && !t.divider
													}).length),
											(n += r)
									} else n += u.selected && !u.disabled && u.visible ? 1 : 0
								}
							} catch (t) {
								i.e(t)
							} finally {
								i.f()
							}
							;(this.allSelected =
								this.data.filter(function (t) {
									return t.selected && !t.disabled && t.visible
								}).length ===
								this.data.filter(function (t) {
									return !t.disabled && t.visible && !t.divider
								}).length),
								t || (this.allSelected ? this.options.onCheckAll() : 0 === n && this.options.onUncheckAll())
						},
					},
					{
						key: 'initFilter',
						value: function () {
							if (((this.filterText = ''), !this.options.filter && this.options.filterByDataLength)) {
								var t,
									e = 0,
									n = l(this.data)
								try {
									for (n.s(); !(t = n.n()).done; ) {
										var i = t.value
										'optgroup' === i.type ? (e += i.children.length) : (e += 1)
									}
								} catch (t) {
									n.e(t)
								} finally {
									n.f()
								}
								this.options.filter = e > this.options.filterByDataLength
							}
						},
					},
					{
						key: 'initDrop',
						value: function () {
							var t = this
							this.initList(),
								this.update(!0),
								this.options.isOpen &&
									setTimeout(function () {
										t.open()
									}, 50),
								this.options.openOnHover &&
									this.$parent.hover(
										function () {
											t.open()
										},
										function () {
											t.close()
										},
									)
						},
					},
					{
						key: 'initList',
						value: function () {
							var t = []
							this.options.filter &&
								t.push(
									'\n        <div class="ms-search">\n          <input type="text" autocomplete="off" autocorrect="off"\n            autocapitalize="off" spellcheck="false"\n            placeholder="'.concat(
										this.options.filterPlaceholder,
										'">\n        </div>\n      ',
									),
								),
								t.push('<ul></ul>'),
								this.$drop.html(t.join('')),
								(this.$ul = this.$drop.find('>ul')),
								this.initListItems()
						},
					},
					{
						key: 'initListItems',
						value: function () {
							var t = this,
								e = this.getListRows(),
								n = 0
							if ((this.options.selectAll && !this.options.single && (n = -1), e.length > Ws.BLOCK_ROWS * Ws.CLUSTER_BLOCKS)) {
								this.virtualScroll && this.virtualScroll.destroy()
								var i = this.$drop.is(':visible')
								i || this.$drop.css('left', -1e4).show()
								var u = function () {
									;(t.updateDataStart = t.virtualScroll.dataStart + n),
										(t.updateDataEnd = t.virtualScroll.dataEnd + n),
										t.updateDataStart < 0 && (t.updateDataStart = 0),
										t.updateDataEnd > t.data.length && (t.updateDataEnd = t.data.length)
								}
								;(this.virtualScroll = new Sc({
									rows: e,
									scrollEl: this.$ul[0],
									contentEl: this.$ul[0],
									callback: function () {
										u(), t.events()
									},
								})),
									u(),
									i || this.$drop.css('left', 0).hide()
							} else this.$ul.html(e.join('')), (this.updateDataStart = 0), (this.updateDataEnd = this.updateData.length), (this.virtualScroll = null)
							this.events()
						},
					},
					{
						key: 'getListRows',
						value: function () {
							var t = this,
								e = []
							return (
								this.options.selectAll &&
									!this.options.single &&
									e.push(
										'\n        <li class="ms-select-all" tabindex="0">\n        <label>\n        <input type="checkbox" '
											.concat(this.selectAllName)
											.concat(this.allSelected ? ' checked="checked"' : '', ' tabindex="-1" />\n        <span>')
											.concat(this.options.formatSelectAll(), '</span>\n        </label>\n        </li>\n      '),
									),
								(this.updateData = []),
								this.data.forEach(function (n) {
									e.push.apply(e, o(t.initListItem(n)))
								}),
								e.push('<li class="ms-no-results">'.concat(this.options.formatNoMatchesFound(), '</li>')),
								e
							)
						},
					},
					{
						key: 'initListItem',
						value: function (t) {
							var e = this,
								n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
								i = t.title ? 'title="'.concat(t.title, '"') : '',
								u = this.options.multiple ? 'multiple' : '',
								r = this.options.single ? 'radio' : 'checkbox',
								s = ''
							if (!t.visible) return []
							if (
								(this.updateData.push(t),
								this.options.single && !this.options.singleRadio && (s = 'hide-radio '),
								t.selected && (s += 'selected '),
								'optgroup' === t.type)
							) {
								var a = this.options.styler(t),
									l = a ? 'style="'.concat(a, '"') : '',
									c = [],
									h =
										this.options.hideOptgroupCheckboxes || this.options.single
											? '<span '.concat(this.selectGroupName, ' data-key="').concat(t._key, '"></span>')
											: '<input type="checkbox"\n          '
													.concat(this.selectGroupName, '\n          data-key="')
													.concat(t._key, '"\n          ')
													.concat(t.selected ? ' checked="checked"' : '', '\n          ')
													.concat(t.disabled ? ' disabled="disabled"' : '', '\n          tabindex="-1"\n        >')
								return (
									s.includes('hide-radio') || (!this.options.hideOptgroupCheckboxes && !this.options.single) || (s += 'hide-radio '),
									c.push(
										'\n        <li class="group '
											.concat(s, '" ')
											.concat(l, ' tabindex="')
											.concat(s.includes('hide-radio') || t.disabled ? -1 : 0, '">\n        <label class="optgroup')
											.concat(this.options.single || t.disabled ? ' disabled' : '', '">\n        ')
											.concat(h)
											.concat(t.label, '\n        </label>\n        </li>\n      '),
									),
									t.children.forEach(function (t) {
										c.push.apply(c, o(e.initListItem(t, 1)))
									}),
									c
								)
							}
							var f = this.options.styler(t),
								d = f ? 'style="'.concat(f, '"') : ''
							return (
								(s += t.classes || ''),
								n && this.options.single && (s += 'option-level-'.concat(n, ' ')),
								t.divider
									? '<li class="option-divider"/>'
									: [
											'\n      <li class="'
												.concat(u, ' ')
												.concat(s, '" ')
												.concat(i, ' ')
												.concat(d, ' tabindex="')
												.concat(t.disabled ? -1 : 0, '">\n      <label class="')
												.concat(t.disabled ? 'disabled' : '', '">\n      <input type="')
												.concat(r, '"\n        value="')
												.concat(t.value, '"\n        data-key="')
												.concat(t._key, '"\n        ')
												.concat(this.selectItemName, '\n        ')
												.concat(t.selected ? ' checked="checked"' : '', '\n        ')
												.concat(t.disabled ? ' disabled="disabled"' : '', '\n        tabindex="-1"\n      >\n      <span>')
												.concat(t.text, '</span>\n      </label>\n      </li>\n    '),
										]
							)
						},
					},
					{
						key: 'events',
						value: function () {
							var e = this
							;(this.$searchInput = this.$drop.find('.ms-search input')),
								(this.$selectAll = this.$drop.find('input['.concat(this.selectAllName, ']'))),
								(this.$selectGroups = this.$drop.find('input['.concat(this.selectGroupName, '],span[').concat(this.selectGroupName, ']'))),
								(this.$selectItems = this.$drop.find('input['.concat(this.selectItemName, ']:enabled'))),
								(this.$disableItems = this.$drop.find('input['.concat(this.selectItemName, ']:disabled'))),
								(this.$noResults = this.$drop.find('.ms-no-results'))
							var n = function (n) {
								n.preventDefault(), t(n.target).hasClass('icon-close') || e[e.options.isOpen ? 'close' : 'open']()
							}
							this.$label &&
								this.$label.length &&
								this.$label.off('click').on('click', function (t) {
									'label' === t.target.nodeName.toLowerCase() && (n(t), (e.options.filter && e.options.isOpen) || e.focus(), t.stopPropagation())
								}),
								this.$choice.off('click').on('click', n).off('focus').on('focus', this.options.onFocus).off('blur').on('blur', this.options.onBlur),
								this.$parent.off('keydown').on('keydown', function (t) {
									27 !== t.which || e.options.keepOpen || (e.close(), e.$choice.focus())
								}),
								this.$close.off('click').on('click', function (t) {
									t.preventDefault(), e._checkAll(!1, !0), e.initSelected(!1), e.updateSelected(), e.update(), e.options.onClear()
								}),
								this.$searchInput
									.off('keydown')
									.on('keydown', function (t) {
										9 === t.keyCode && t.shiftKey && e.close()
									})
									.off('keyup')
									.on('keyup', function (t) {
										if (e.options.filterAcceptOnEnter && [13, 32].includes(t.which) && e.$searchInput.val()) {
											if (e.options.single) {
												var n = e.$selectItems.closest('li').filter(':visible')
												n.length && e.setSelects([n.first().find('input['.concat(e.selectItemName, ']')).val()])
											} else e.$selectAll.click()
											return e.close(), void e.focus()
										}
										e.filter()
									}),
								this.$selectAll.off('click').on('click', function (n) {
									e._checkAll(t(n.currentTarget).prop('checked'))
								}),
								this.$selectGroups.off('click').on('click', function (n) {
									var i = t(n.currentTarget),
										u = i.prop('checked'),
										r = ph(e.data, '_key', i.data('key'))
									e._checkGroup(r, u),
										e.options.onOptgroupClick(
											vh({
												label: r.label,
												selected: r.selected,
												data: r._data,
												children: r.children.map(function (t) {
													return vh({ text: t.text, value: t.value, selected: t.selected, disabled: t.disabled, data: t._data })
												}),
											}),
										)
								}),
								this.$selectItems.off('click').on('click', function (n) {
									var i = t(n.currentTarget),
										u = i.prop('checked'),
										r = ph(e.data, '_key', i.data('key')),
										o = function () {
											e.options.single && e.options.isOpen && !e.options.keepOpen && e.close()
										}
									!1 !== e.options.onBeforeClick(r)
										? (e._check(r, u), e.options.onClick(vh({ text: r.text, value: r.value, selected: r.selected, data: r._data })), o())
										: o()
								}),
								this.$ul
									.find('li')
									.off('keydown')
									.on('keydown', function (n) {
										var i,
											u = t(n.currentTarget)
										switch (n.key) {
											case 'ArrowUp':
												n.preventDefault(), ((i = u.prev('li.option-divider')).length ? i : u).prev().trigger('focus')
												break
											case 'ArrowDown':
												n.preventDefault(), ((i = u.next('li.option-divider')).length ? i : u).next().trigger('focus')
												break
											case 'Enter':
												n.preventDefault(), u.find('input').trigger('click'), e.options.single && e.$choice.trigger('focus')
										}
									})
						},
					},
					{
						key: 'initView',
						value: function () {
							var t
							window.getComputedStyle
								? 'auto' === (t = window.getComputedStyle(this.$el[0]).width) && (t = this.$drop.outerWidth() + 20)
								: (t = this.$el.outerWidth() + 20),
								this.$parent.css('width', this.options.width || t),
								this.$el.show().addClass('ms-offscreen')
						},
					},
					{
						key: 'open',
						value: function () {
							if (!this.$choice.hasClass('disabled')) {
								if (
									((this.options.isOpen = !0),
									this.$parent.addClass('ms-parent-open'),
									this.$choice.find('>div').addClass('open'),
									this.$drop[this.animateMethod('show')](),
									this.$selectAll.parent().show(),
									this.$noResults.hide(),
									this.data.length || (this.$selectAll.parent().hide(), this.$noResults.show()),
									this.options.container)
								) {
									var e = this.$drop.offset()
									this.$drop.appendTo(t(this.options.container)),
										this.$drop.offset({ top: e.top, left: e.left }).css('min-width', 'auto').outerWidth(this.$parent.outerWidth())
								}
								var n = this.options.maxHeight
								'row' === this.options.maxHeightUnit && (n = this.$drop.find('>ul>li').first().outerHeight() * this.options.maxHeight),
									this.$drop.find('>ul').css('max-height', ''.concat(n, 'px')),
									this.$drop.find('.multiple').css('width', ''.concat(this.options.multipleWidth, 'px')),
									this.data.length && this.options.filter && (this.$searchInput.val(''), this.$searchInput.focus(), this.filter(!0)),
									this.options.onOpen()
							}
						},
					},
					{
						key: 'close',
						value: function () {
							;(this.options.isOpen = !1),
								this.$parent.removeClass('ms-parent-open'),
								this.$choice.find('>div').removeClass('open'),
								this.$drop[this.animateMethod('hide')](),
								this.options.container && (this.$parent.append(this.$drop), this.$drop.css({ top: 'auto', left: 'auto' })),
								this.options.onClose()
						},
					},
					{
						key: 'animateMethod',
						value: function (t) {
							return { show: { fade: 'fadeIn', slide: 'slideDown' }, hide: { fade: 'fadeOut', slide: 'slideUp' } }[t][this.options.animate] || t
						},
					},
					{
						key: 'update',
						value: function (t) {
							var e = this.getSelects(),
								n = this.getSelects('text')
							this.options.displayValues && (n = e)
							var i = this.$choice.find('>span'),
								u = e.length,
								r = ''
							0 === u
								? i.addClass('placeholder').html(this.options.placeholder)
								: (r =
										u < this.options.minimumCountSelected
											? n.join(this.options.displayDelimiter)
											: this.options.formatAllSelected() && u === this.dataTotal
												? this.options.formatAllSelected()
												: this.options.ellipsis && u > this.options.minimumCountSelected
													? ''.concat(n.slice(0, this.options.minimumCountSelected).join(this.options.displayDelimiter), '...')
													: this.options.formatCountSelected() && u > this.options.minimumCountSelected
														? this.options.formatCountSelected(u, this.dataTotal)
														: n.join(this.options.displayDelimiter)),
								r && i.removeClass('placeholder').html(r),
								this.options.displayTitle && i.prop('title', this.getSelects('text')),
								this.$el.val(this.getSelects()),
								t || this.$el.trigger('change')
						},
					},
					{
						key: 'updateSelected',
						value: function () {
							for (var t = this.updateDataStart; t < this.updateDataEnd; t++) {
								var e = this.updateData[t]
								this.$drop.find('input[data-key='.concat(e._key, ']')).prop('checked', e.selected).closest('li').toggleClass('selected', e.selected)
							}
							var n =
								0 ===
								this.data.filter(function (t) {
									return t.visible
								}).length
							this.$selectAll.length && this.$selectAll.prop('checked', this.allSelected).closest('li').toggle(!n),
								this.$noResults.toggle(n),
								this.virtualScroll && (this.virtualScroll.rows = this.getListRows())
						},
					},
					{
						key: 'getData',
						value: function () {
							return this.options.data
						},
					},
					{
						key: 'getOptions',
						value: function () {
							var e = t.extend({}, this.options)
							return delete e.data, t.extend(!0, {}, e)
						},
					},
					{
						key: 'refreshOptions',
						value: function (e) {
							;(function (t, e, n) {
								var i = Object.keys(t),
									u = Object.keys(e)
								if (n && i.length !== u.length) return !1
								for (var r = 0, o = i; r < o.length; r++) {
									var s = o[r]
									if (u.includes(s) && t[s] !== e[s]) return !1
								}
								return !0
							})(this.options, e, !0) || ((this.options = t.extend(this.options, e)), this.destroy(), this.init())
						},
					},
					{
						key: 'getSelects',
						value: function () {
							var t,
								e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 'value',
								n = [],
								i = l(this.data)
							try {
								for (i.s(); !(t = i.n()).done; ) {
									var u = t.value
									if ('optgroup' === u.type) {
										var r = u.children.filter(function (t) {
											return t.selected
										})
										if (!r.length) continue
										if ('value' === e || this.options.single)
											n.push.apply(
												n,
												o(
													r.map(function (t) {
														return ('value' === e && t._value) || t[e]
													}),
												),
											)
										else {
											var s = []
											s.push('['),
												s.push(u.label),
												s.push(
													': '.concat(
														r
															.map(function (t) {
																return t[e]
															})
															.join(', '),
													),
												),
												s.push(']'),
												n.push(s.join(''))
										}
									} else u.selected && n.push(('value' === e && u._value) || u[e])
								}
							} catch (t) {
								i.e(t)
							} finally {
								i.f()
							}
							return n
						},
					},
					{
						key: 'setSelects',
						value: function (e) {
							var n,
								i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 'value',
								u = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
								r = !1,
								o = function (n) {
									var u,
										o = l(n)
									try {
										for (o.s(); !(u = o.n()).done; ) {
											var s = u.value,
												a = !1
											'text' === i
												? (a = e.includes(t('<div>').html(s.text).text().trim()))
												: (a = e.includes(s._value || s.value)) || s.value !== ''.concat(+s.value) || (a = e.includes(+s.value)),
												s.selected !== a && (r = !0),
												(s.selected = a)
										}
									} catch (t) {
										o.e(t)
									} finally {
										o.f()
									}
								},
								s = l(this.data)
							try {
								for (s.s(); !(n = s.n()).done; ) {
									var a = n.value
									'optgroup' === a.type ? o(a.children) : o([a])
								}
							} catch (t) {
								s.e(t)
							} finally {
								s.f()
							}
							r && (this.initSelected(u), this.updateSelected(), this.update(u))
						},
					},
					{
						key: 'enable',
						value: function () {
							this.$choice.removeClass('disabled')
						},
					},
					{
						key: 'disable',
						value: function () {
							this.$choice.addClass('disabled')
						},
					},
					{
						key: 'check',
						value: function (t) {
							var e = ph(this.data, 'value', t)
							e && this._check(e, !0)
						},
					},
					{
						key: 'uncheck',
						value: function (t) {
							var e = ph(this.data, 'value', t)
							e && this._check(e, !1)
						},
					},
					{
						key: '_check',
						value: function (t, e) {
							this.options.single && this._checkAll(!1, !0), (t.selected = e), this.initSelected(), this.updateSelected(), this.update()
						},
					},
					{
						key: 'checkAll',
						value: function () {
							this._checkAll(!0)
						},
					},
					{
						key: 'uncheckAll',
						value: function () {
							this._checkAll(!1)
						},
					},
					{
						key: '_checkAll',
						value: function (t, e) {
							var n,
								i = l(this.data)
							try {
								for (i.s(); !(n = i.n()).done; ) {
									var u = n.value
									'optgroup' === u.type ? this._checkGroup(u, t, !0) : u.disabled || u.divider || (!e && !u.visible) || (u.selected = t)
								}
							} catch (t) {
								i.e(t)
							} finally {
								i.f()
							}
							e || (this.initSelected(), this.updateSelected(), this.update())
						},
					},
					{
						key: '_checkGroup',
						value: function (t, e, n) {
							;(t.selected = e),
								t.children.forEach(function (t) {
									t.disabled || t.divider || (!n && !t.visible) || (t.selected = e)
								}),
								n || (this.initSelected(), this.updateSelected(), this.update())
						},
					},
					{
						key: 'checkInvert',
						value: function () {
							if (!this.options.single) {
								var t,
									e = l(this.data)
								try {
									for (e.s(); !(t = e.n()).done; ) {
										var n = t.value
										if ('optgroup' === n.type) {
											var i,
												u = l(n.children)
											try {
												for (u.s(); !(i = u.n()).done; ) {
													var r = i.value
													r.divider || (r.selected = !r.selected)
												}
											} catch (t) {
												u.e(t)
											} finally {
												u.f()
											}
										} else n.divider || (n.selected = !n.selected)
									}
								} catch (t) {
									e.e(t)
								} finally {
									e.f()
								}
								this.initSelected(), this.updateSelected(), this.update()
							}
						},
					},
					{
						key: 'focus',
						value: function () {
							this.$choice.focus(), this.options.onFocus()
						},
					},
					{
						key: 'blur',
						value: function () {
							this.$choice.blur(), this.options.onBlur()
						},
					},
					{
						key: 'refresh',
						value: function () {
							this.destroy(), this.init()
						},
					},
					{
						key: 'filter',
						value: function (t) {
							var e = this.$searchInput.val().trim(),
								n = e.toLowerCase()
							if (this.filterText !== n) {
								this.filterText = n
								var i,
									u = l(this.data)
								try {
									for (u.s(); !(i = u.n()).done; ) {
										var r = i.value
										if ('optgroup' === r.type)
											if (this.options.filterGroup) {
												var o = this.options.customFilter({
													label: dh(r.label.toString().toLowerCase()),
													search: dh(n),
													originalLabel: r.label,
													originalSearch: e,
													row: r,
												})
												r.visible = o
												var s,
													a = l(r.children)
												try {
													for (a.s(); !(s = a.n()).done; ) {
														s.value.visible = o
													}
												} catch (t) {
													a.e(t)
												} finally {
													a.f()
												}
											} else {
												var c,
													h = l(r.children)
												try {
													for (h.s(); !(c = h.n()).done; ) {
														var f = c.value
														f.visible = this.options.customFilter({
															text: dh(f.text.toString().toLowerCase()),
															search: dh(n),
															originalText: f.text,
															originalSearch: e,
															row: f,
															parent: r,
														})
													}
												} catch (t) {
													h.e(t)
												} finally {
													h.f()
												}
												r.visible =
													r.children.filter(function (t) {
														return t.visible
													}).length > 0
											}
										else
											r.visible = this.options.customFilter({
												text: dh(r.text.toString().toLowerCase()),
												search: dh(n),
												originalText: r.text,
												originalSearch: e,
												row: r,
											})
									}
								} catch (t) {
									u.e(t)
								} finally {
									u.f()
								}
								this.initListItems(), this.initSelected(t), this.updateSelected(), t || this.options.onFilter(e)
							}
						},
					},
					{
						key: 'destroy',
						value: function () {
							this.$parent &&
								(this.$el.before(this.$parent).removeClass('ms-offscreen'),
								null !== this.tabIndex && this.$el.attr('tabindex', this.tabIndex),
								this.$parent.remove(),
								this.fromHtml && (delete this.options.data, (this.fromHtml = !1)))
						},
					},
				]),
				i
			)
		})()
	;(t.fn.multipleSelect = function (n) {
		for (var i = arguments.length, u = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++) u[r - 1] = arguments[r]
		var o
		return (
			this.each(function (i, r) {
				var s = t(r),
					a = s.data('multipleSelect'),
					l = t.extend({}, s.data(), 'object' === e(n) && n)
				if ((a || ((a = new gh(s, l)), s.data('multipleSelect', a)), 'string' == typeof n)) {
					var c
					if (t.inArray(n, Ws.METHODS) < 0) throw new Error('Unknown method: '.concat(n))
					;(o = (c = a)[n].apply(c, u)), 'destroy' === n && s.removeData('multipleSelect')
				} else a.init()
			}),
			void 0 !== o ? o : this
		)
	}),
		(t.fn.multipleSelect.Constructor = gh),
		(t.fn.multipleSelect.defaults = Ws.DEFAULTS),
		(t.fn.multipleSelect.locales = Ws.LOCALES),
		(t.fn.multipleSelect.methods = Ws.METHODS)
})
